import { useState } from 'react';
import toast from 'react-hot-toast';
import { Modal } from '../../components/Modal.tsx';
import { Button, TextField } from '../../components/ui.tsx';
import { useAddUrlMedia } from '../../api/media.ts';
import { ApiError } from '../../api/client.ts';

export function AddUrlModal({ onClose }: { onClose: () => void }) {
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const add = useAddUrlMedia();

  const urlValid = /^https?:\/\/.+/i.test(url);
  const canSubmit = name.trim() && urlValid && !add.isPending;

  function submit() {
    setSubmitted(true);
    if (!name.trim() || !urlValid) return;
    add.mutate(
      { src_url: url.trim(), name: name.trim() },
      {
        onSuccess: () => {
          toast.success('URL content added');
          onClose();
        },
        onError: (e) => toast.error(e instanceof ApiError ? e.message : 'Failed'),
      },
    );
  }

  return (
    <Modal
      title="Add URL content"
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="primary" onClick={submit} disabled={!canSubmit}>
            Add
          </Button>
        </>
      }
    >
      <p className="text-dim mb-4">Show a live web page on screens — a menu, dashboard, or widget.</p>
      <TextField
        label="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Local weather"
        error={submitted && !name.trim() ? 'A name is required' : undefined}
      />
      <TextField
        label="URL"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        placeholder="https://example.com/menu"
        error={submitted && !urlValid ? 'Enter a valid http(s) URL' : undefined}
      />
    </Modal>
  );
}
